{
  "panel": {
    "title": "نوٹس",
    "newNote_title": "نیا نوٹ",
    "search_placeholder": "نوٹس تلاش کریں…",
    "search_aria": "نوٹس تلاش کریں",
    "clearSearch_aria": "تلاش صاف کریں",
    "editorPlaceholder": "آپ کے ذہن میں کیا ہے…",
    "titleInput_placeholder": "کوئی عنوان نہیں",
    "untitled": "بلا عنوان",
    "emptyNote": "خالی نوٹ",
    "loadingNotes": "نوٹس لوڈ ہو رہے ہیں…",
    "noNotesYet": "ابھی کوئی نوٹ نہیں۔ ایک بنانے کے لیے + دبائیں۔",
    "noResults": "\"{{query}}\" کے لیے کوئی نتیجہ نہیں",
    "noNotesTagged": "{{tag}} ٹیگ والے کوئی نوٹس نہیں",
    "tagFilterAll": "تمام",
    "filterByTag_aria": "ٹیگ کے لحاظ سے فلٹر کریں",
    "templates": "ٹیمپلیٹس",
    "editorTheme_aria": "ایڈیٹر تھیم",
    "themeActive_aria": "{{theme}} تھیم (فعال)",
    "theme_aria": "{{theme}} تھیم",
    "themeName": {
      "dark": "تاریک",
      "sepia": "سیپیا",
      "light": "روشن",
      "forest": "جنگل"
    },
    "voice": "آواز",
    "voice_title": "صوتی نوٹ",
    "voiceUnavailable_title": "اس براؤزر میں تقریر دستیاب نہیں",
    "openVoiceRecorder_aria": "صوتی نوٹ ریکارڈر کھولیں",
    "summarizing_title": "خلاصہ بنایا جا رہا ہے…",
    "summarize_title": "خلاصہ بنائیں",
    "summarizeNote_aria": "نوٹ کا خلاصہ بنائیں",
    "aiCommands_title": "AI کمانڈز  Cmd+K",
    "openAiPalette_aria": "AI کمانڈ پیلیٹ کھولیں",
    "enterFocusMode_title": "فوکس موڈ  Cmd+Shift+F",
    "exitFocusMode_title": "فوکس موڈ سے باہر نکلیں  Cmd+Shift+F",
    "enterFocusMode_aria": "فوکس موڈ میں داخل ہوں",
    "exitFocusMode_aria": "فوکس موڈ سے باہر نکلیں",
    "export_title": "نوٹ برآمد کریں",
    "delete_title": "نوٹ حذف کریں",
    "delete_aria": "نوٹ حذف کریں",
    "moreActions_title": "مزید کارروائیاں",
    "wordCount_one": "{{formatted}} لفظ · ~{{minutes}} منٹ مطالعہ",
    "wordCount_other": "{{formatted}} الفاظ · ~{{minutes}} منٹ مطالعہ",
    "referencedBy_one": "{{count}} کی طرف سے حوالہ دیا گیا",
    "referencedBy_other": "{{count}} کی طرف سے حوالہ دیا گیا",
    "noMatchingNotes": "کوئی مماثل نوٹس نہیں",
    "mobileTabs_aria": "نوٹس کا منظر",
    "mobileTabNotes": "نوٹس",
    "mobileTabEditor": "ایڈیٹر",
    "saveFailed": "نوٹ محفوظ نہیں ہو سکا: {{message}}",
    "deleteFailed": "نوٹ حذف نہیں ہو سکا",
    "loadFailed": "نوٹس لوڈ نہیں ہو سکے",
    "analyzeFailed": "نوٹ کا تجزیہ نہیں ہو سکا",
    "aiCommandFailed": "AI کمانڈ ناکام ہو گئی",
    "unknownError": "نامعلوم خرابی"
  },
  "paywall": {
    "title": "نوٹس Rhemn Pro کا حصہ ہے",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "ہم آہنگ نوٹس، براؤزر پر مبنی املا، اور منظم AI خلاصے کھولیں۔"
  },
  "format": {
    "bold": "موٹا",
    "italic": "ترچھا",
    "strikethrough": "خط زدہ",
    "inlineCode": "اِن لائن کوڈ",
    "heading1": "عنوان 1",
    "heading2": "عنوان 2",
    "heading3": "عنوان 3",
    "bulletList": "بلٹ فہرست",
    "numberedList": "نمبر شدہ فہرست",
    "blockquote": "اقتباس",
    "codeBlock": "کوڈ بلاک",
    "toggleBold_aria": "موٹا تبدیل کریں",
    "toggleItalic_aria": "ترچھا تبدیل کریں",
    "toggleStrikethrough_aria": "خط زدہ تبدیل کریں",
    "toggleInlineCode_aria": "اِن لائن کوڈ تبدیل کریں",
    "toggleBulletList_aria": "بلٹ فہرست تبدیل کریں",
    "toggleNumberedList_aria": "نمبر شدہ فہرست تبدیل کریں",
    "toggleBlockquote_aria": "اقتباس تبدیل کریں",
    "formatOptions_aria": "فارمیٹ کے اختیارات"
  },
  "analysis": {
    "heading": "خلاصہ",
    "onDevice": "⚡ آلے پر",
    "onDevice_aria": "آلے پر کارروائی شدہ",
    "applyToNote_title": "نوٹ پر لاگو کریں",
    "applyToNote_aria": "خلاصہ نوٹ پر لاگو کریں",
    "summaryLabel": "خلاصہ",
    "keyPointsLabel": "اہم نکات",
    "noKeyPoints": "اس نوٹ کے لیے کوئی اہم نکات نہیں ملے۔"
  },
  "export": {
    "markdown": "Markdown کے طور پر برآمد کریں",
    "plainText": "سادہ متن کے طور پر برآمد کریں",
    "pdf": "PDF کے طور پر برآمد کریں",
    "allZip": "سب کو ZIP کے طور پر برآمد کریں",
    "label": "برآمد کریں"
  },
  "cmdk": {
    "dialog_aria": "AI کمانڈ پیلیٹ",
    "input_placeholder": "AI سے پوچھیں یا کوئی کمانڈ چلائیں…",
    "esc": "Esc",
    "back_aria": "واپس",
    "translateTo": "ترجمہ کریں اس میں",
    "language_placeholder": "زبان…",
    "aiActions": "AI کارروائیاں",
    "noCommandsMatch": "\"{{query}}\" سے کوئی کمانڈ مماثل نہیں",
    "continue": {
      "label": "لکھنا جاری رکھیں",
      "description": "جہاں چھوڑا تھا وہاں سے جاری رکھیں"
    },
    "summarize": {
      "label": "انتخاب کا خلاصہ بنائیں",
      "description": "اہم نکات تک سمیٹیں"
    },
    "formal": {
      "label": "اسے رسمی بنائیں",
      "description": "لہجے کو پیشہ ورانہ بنائیں"
    },
    "simplify": {
      "label": "آسان بنائیں",
      "description": "مختصر، واضح زبان"
    },
    "translate": {
      "label": "ترجمہ کریں اس میں…",
      "description": "کسی دوسری زبان میں ترجمہ کریں"
    },
    "expand": {
      "label": "اس بلٹ کو بڑھائیں",
      "description": "منتخب بلٹ کو نثر میں بڑھائیں"
    },
    "languages": {
      "Spanish": "ہسپانوی",
      "Arabic": "عربی",
      "French": "فرانسیسی",
      "German": "جرمن",
      "Japanese": "جاپانی",
      "Portuguese": "پرتگالی"
    }
  },
  "templates": {
    "dialog_aria": "ٹیمپلیٹ منتخب کریں",
    "header": "ایک ٹیمپلیٹ منتخب کریں",
    "builtInLabel": "بلٹ اِن",
    "myTemplatesLabel": "میرے ٹیمپلیٹس",
    "saveCurrent": "موجودہ نوٹ کو ٹیمپلیٹ کے طور پر محفوظ کریں",
    "myTemplatesEmpty": "آپ کے محفوظ کردہ ٹیمپلیٹس یہاں ظاہر ہوں گے",
    "useTemplate": "ٹیمپلیٹ استعمال کریں",
    "meeting": {
      "name": "میٹنگ نوٹس",
      "description": "فیصلے اور کام کے نکات محفوظ کریں",
      "structure": "شرکاء / ایجنڈا / نوٹس / کارروائیاں"
    },
    "journal": {
      "name": "روزانہ ڈائری",
      "description": "اپنے دن پر غور کریں",
      "structure": "شکرگزاری / آج کی کامیابیاں / نوٹس"
    },
    "book": {
      "name": "کتاب کا خلاصہ",
      "description": "کتاب کے اہم خیالات محفوظ کریں",
      "structure": "بنیادی خیال / اہم اقتباسات / حاصل کلام"
    },
    "project": {
      "name": "پروجیکٹ کا خاکہ",
      "description": "دائرہ کار، اہداف اور متعلقین کا خاکہ بنائیں",
      "structure": "ہدف / دائرہ کار / خطرات / ٹائم لائن"
    },
    "brainstorm": {
      "name": "غور و فکر",
      "description": "آزاد انداز میں خیالات محفوظ کریں",
      "structure": "موضوع / خیالات / اگلے اقدامات"
    },
    "weekly": {
      "name": "ہفتہ وار جائزہ",
      "description": "اپنے ہفتے کا جائزہ لیں اور منصوبہ بنائیں",
      "structure": "کامیابیاں / مشکلات / توجہ کے شعبے"
    }
  },
  "voice": {
    "dialog_aria": "صوتی نوٹ ریکارڈر",
    "cancel_aria": "منسوخ کریں",
    "statusRecording": "ریکارڈنگ ہو رہی ہے",
    "statusTranscribing": "نقل تیار ہو رہی ہے…",
    "statusReview": "جائزہ",
    "skip": "چھوڑیں",
    "mark": "نشان لگائیں",
    "mark_title": "ٹائم اسٹیمپ نشان لگائیں",
    "captureMeeting": "میٹنگ ریکارڈ کریں",
    "captureMeeting_title": "میٹنگ ٹیب سے آڈیو بھی ریکارڈ کریں",
    "meeting": "میٹنگ",
    "meeting_title": "میٹنگ ٹیب ریکارڈ ہو رہا ہے",
    "markers_aria": "ٹائم اسٹیمپ نشان",
    "listening": "سن رہا ہے…",
    "micDenied": "مائیکروفون تک رسائی بند ہے۔ ترتیبات میں اجازت دیں، پھر دوبارہ کوشش کریں۔",
    "captureFailed": "ریکارڈنگ شروع نہیں ہو سکی۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔",
    "tabPicker_aria": "ریکارڈ کرنے کے لیے میٹنگ ٹیب منتخب کریں",
    "captureFrom": "آڈیو یہاں سے ریکارڈ کریں…",
    "noAudibleTab": "کوئی ٹیب آڈیو نہیں چلا رہا۔ اپنی میٹنگ کھولیں اور یقینی بنائیں کہ کوئی بول رہا ہے، پھر دوبارہ کوشش کریں۔",
    "tabPickerCancel": "منسوخ کریں",
    "tabTranscript": "نقل",
    "structuring": "ترتیب دی جا رہی ہے…",
    "structuredNote": "منظم نوٹ",
    "structureFailed": "منظم نوٹ نہیں بن سکا۔",
    "retryStructure": "دوبارہ کوشش کریں",
    "browserTranscript": "براؤزر نقل",
    "nothingCaptured": "کچھ بھی ریکارڈ نہیں ہوا۔",
    "buildingStructured": "منظم نوٹ بنایا جا رہا ہے…",
    "cancel": "منسوخ کریں",
    "stop": "روکیں",
    "recordAgain": "دوبارہ ریکارڈ کریں",
    "saveToNote": "نوٹ میں محفوظ کریں",
    "statusMeeting": "میٹنگ",
    "captureStrip_aria": "{{tab}} سے آڈیو کیپچر ہو رہی ہے",
    "stopCapture": "کیپچر روکیں",
    "stopCapture_title": "ٹیب کیپچر روکیں — مائیکروفون ریکارڈ کرتا رہے گا",
    "stopsIn": "{{time}} میں رک جائے گی",
    "autoStopped": "ریکارڈنگ 60 منٹ کی حد پر رک گئی۔",
    "autoStoppedQuota": "ریکارڈنگ رک گئی — اس مہینے کے ٹرانسکرپشن منٹ استعمال ہو چکے ہیں۔",
    "captureLost": "میٹنگ ٹیب بند ہو گئی۔ آپ کا مائیکروفون اب بھی ریکارڈ کر رہا ہے۔",
    "tabSummary": "خلاصہ",
    "noSpeakers": "مقررین کی شناخت نہیں ہو سکی",
    "speakerN": "مقرر {{number}}",
    "renameSpeaker_aria": "{{name}} کا نام بدلیں — ان کی تمام سطروں پر لاگو ہوگا",
    "renameSpeaker_input_aria": "مقرر کا نام",
    "turnTime_title": "{{time}} پر کہا گیا",
    "actionItemsTitle": "قابلِ عمل نکات",
    "actionsCount": "{{total}} میں سے {{checked}}",
    "addToTasks_one": "{{count}} کو ٹاسکس میں شامل کریں",
    "addToTasks_other": "{{count}} کو ٹاسکس میں شامل کریں",
    "addToTasksZero": "ٹاسکس میں شامل کریں",
    "adding": "شامل کیا جا رہا ہے…",
    "tasksAdded_one": "{{count}} ٹاسک شامل ہوا",
    "tasksAdded_other": "{{count}} ٹاسک شامل ہوئے",
    "viewTasks": "دیکھیں",
    "addFailed": "شامل نہیں ہو سکا — دوبارہ کوشش کریں۔",
    "minutesLeft_one": "{{count}} منٹ باقی",
    "minutesLeft_other": "{{count}} منٹ باقی",
    "minutesLeftShort_one": "{{count}} منٹ باقی",
    "minutesLeftShort_other": "{{count}} منٹ باقی",
    "minutesLeft_title": "اس مہینے {{count}} ٹرانسکرپشن منٹ باقی ہیں",
    "quotaExhausted": "اس مہینے کے میٹنگ منٹ استعمال ہو چکے ہیں۔ یہ {{date}} کو تجدید ہوں گے۔",
    "quotaUnknown": "باقی منٹ معلوم نہیں — ریکارڈنگ ماہانہ حد تک پہنچ سکتی ہے",
    "meetingProRequired": "میٹنگ ٹرانسکرپشن Pro کا حصہ ہے۔ آپ کی لائیو ٹرانسکرپٹ نیچے محفوظ ہے۔",
    "gateTitle": "میٹنگ ریکارڈنگ",
    "gateBody": "اپنے مائیکروفون کے ساتھ میٹنگ ٹیب ریکارڈ کریں — مقررین کی شناخت اور قابلِ عمل نکات کے اخراج کے ساتھ۔ Pro میں شامل ہے۔",
    "gateLater": "ابھی نہیں",
    "gateCta": "Pro دیکھیں",
    "roomOption": "کوئی ٹیب نہیں — کمرہ ریکارڈ کریں",
    "roomHint": "اسپیکر پر کوئی کال، کوئی الگ ایپ، یا کمرے میں موجود لوگ — جو کچھ بھی آپ باآواز سن سکتے ہیں۔",
    "roomHint_title": "اگر دوسرا فریق آپ کے ہیڈفون میں ہے تو مائیکروفون اسے نہیں سن سکتا — اسپیکر استعمال کریں۔",
    "recordRoom": "کمرہ ریکارڈ کریں",
    "recordRoom_title": "ہر اس شخص کو ریکارڈ کریں جسے مائیکروفون سن سکتا ہے — مقررین کی شناخت کے ساتھ",
    "roomStart": "شروع کریں",
    "statusRoom": "کمرہ",
    "roomStrip": "کمرہ ریکارڈ ہو رہا ہے",
    "roomStrip_aria": "کمرہ ریکارڈ ہو رہا ہے — ہر وہ شخص جسے مائیکروفون سنتا ہے",
    "roomOff": "بند کریں",
    "roomOff_title": "روم موڈ بند کریں — یہ ایک عام صوتی نوٹ بن جائے گا",
    "roomRenameHint": "نام بدلنے کے لیے کسی نام پر ٹیپ کریں — ان میں سے ایک آپ ہیں۔",
    "gateBodyRoom": "اپنے ارد گرد کہی جانے والی باتیں ریکارڈ کریں — مقررین کی شناخت اور قابلِ عمل نکات کے اخراج کے ساتھ۔ Pro میں شامل ہے۔",
    "roomHintDevice": "اس ڈیوائس پر ہونے والی کالیں ریکارڈ نہیں ہو سکتیں — iOS انہیں نجی رکھتا ہے۔ اسپیکر پر کوئی دوسرا فون، یا کمرے میں ہونے والی گفتگو، ریکارڈ ہو سکتی ہے۔",
    "autoStoppedSize": "ریکارڈنگ اپ لوڈ سائز کی حد پر رک گئی۔",
    "tooLarge": "ریکارڈنگ اپ لوڈ کے لیے بہت بڑی تھی، اس لیے ٹرانسکرائب نہیں ہو سکی۔",
    "destTo": "فہرست",
    "dest_aria": "فہرست میں شامل کریں: {{name}}",
    "destMenu_aria": "ایک فہرست منتخب کریں",
    "destNewPending_aria": "نئی فہرست: {{name}}"
  },
  "meetingNotice": {
    "title": "میٹنگز، آپ کے نوٹس میں",
    "body": "Rhemn اب آپ کی منتخب کردہ میٹنگ ٹیب ریکارڈ کر سکتا ہے — صرف اس وقت جب آپ وائس نوٹ ریکارڈ کر رہے ہوں، اور صرف وہی ٹیب جو آپ چنیں۔",
    "factPrivacy": "آڈیو آپ کی ٹرانسکرپٹ بنانے کے لیے پروسیس ہو کر ضائع کر دی جاتی ہے۔ ریکارڈنگز کبھی محفوظ نہیں ہوتیں۔",
    "factControl": "جب تک آپ ریکارڈ نہ دبائیں اور ٹیب نہ چنیں، کچھ بھی کیپچر نہیں ہوتا۔",
    "cta": "سمجھ گیا",
    "privacyLink": "ہماری پرائیویسی پالیسی پڑھیں",
    "dialog_aria": "میٹنگ ریکارڈنگ کی نئی اجازت کے بارے میں"
  }
}
